import React, { useMemo } from 'react';

interface BlobProps {
  className?: string;
}

const FeatureBlobOne: React.FC<BlobProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 437 863"
  >
    <circle cx="211.5" cy="768.5" r="26.5" fill="#2980FF" />
    <path
      fill="#2980FF"
      fillRule="evenodd"
      d="M-295.87 726.33c-66.85-73.52-114.6-173.43-103.14-270.59 10.58-89.83 108.5-134.5 159.56-208.2 41.06-59.25 51.6-137.7 109.67-180.37C-65.43 19.89 15.05-6.15 95.7 1.33c84.46 7.83 177.77 36.76 225.75 107.69 46.5 68.74-8.46 159.6 9.52 240.09 19.69 88.05 132.34 163.23 99.07 245.75-32.6 80.83-161.35 51.7-236.59 95.33C110.1 738.52 66.96 854.43-29.98 861.6c-100.43 7.42-197.15-59.66-265.9-135.26Z"
      clipRule="evenodd"
    />
  </svg>
);

const FeatureBlobTwo: React.FC<BlobProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 817 877"
  >
    <path
      fill="#F8B622"
      d="M317.22 268.32c-8.63-4.18-13.95-13.2-18.43-13.8-2.6-.31-8.4 2.4-12.98 4.86-.55.28-1.18.18-1.57-.2-3.9-3.6-8.95-7.78-11.54-8.18-4.57-.54-11.67 6.81-21.06 8.66-.34.08-.39.6-.08.68 10.64 4.23 15.2-2.71 19.9-2.05 2.84.38 6.44 5.83 8.85 10.22a4.31 4.31 0 0 0 7.08.91c3.35-3.69 8-8.05 10.9-7.65 4.71.66 7.63 8.55 18.84 7.23.32 0 .44-.49.09-.68Z"
    />
    <circle cx="133" cy="393" r="133" fill="#C5DCFF" />
    <path
      fill="#F8B622"
      fillRule="evenodd"
      d="M752.75.66c99.26 4.72 203.67 41.6 264.27 118.4 56.03 71 18.38 171.83 34.39 260.05 12.87 70.93 60.89 133.85 49.99 205.1-12.07 78.92-50.56 154.24-112.87 205.98-65.26 54.18-151.7 99.7-235.77 83.48-81.5-15.72-106.88-118.85-176.51-163.03-76.18-48.35-209-21.86-243.82-103.73-34.11-80.2 77.53-150.65 99.88-234.7 24.76-93.1-26.7-205.58 36.78-279.19C534.87 16.76 650.7-4.18 752.76.66Z"
      clipRule="evenodd"
    />
  </svg>
);

const FeatureBlobThree: React.FC<BlobProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 327 560"
  >
    <path
      fill="#C5DCFF"
      fillRule="evenodd"
      d="M-305.53 223.6c8.5-71.04 40.37-144.13 98.66-183.7C-152.98 3.3-82.5 35.53-18.31 28.6 33.3 23 80.97-8.26 131.58 3.24 187.65 16 239.77 47.52 273.7 94.95c35.56 49.66 63.8 114.09 47.82 173.65-15.5 57.72-90.87 70.64-126.2 118.37-38.66 52.23-26.47 149-87.07 169.79C48.9 577.13 4.04 493.3-55.17 472.92c-65.6-22.58-149.04 8.59-198.64-40.8-51.39-51.18-60.47-135.45-51.72-208.51Z"
      clipRule="evenodd"
    />
  </svg>
);

const FeatureBlobFour: React.FC<BlobProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 544 772"
  >
    <path
      fill="#124CCC"
      fillRule="evenodd"
      d="M2.49 424.62c-8.64-98.99 13.9-207.4 81.88-277.76 62.85-65.05 167.81-41.26 253.1-68.96C406.02 55.64 461.92-.4 533.98.85c79.84 1.38 159.64 29.42 219.26 84.23 62.45 57.4 119.16 136.95 114.36 222.45-4.65 82.86-103.44 121.85-137.9 196.78-37.68 81.97 6.39 210.03-70.07 255.52-74.9 44.56-159.7-56.62-245.98-67.5-95.58-12.04-200.14 54.04-281.6 1C47.66 638.38 11.37 526.41 2.5 424.62Z"
      clipRule="evenodd"
    />
  </svg>
);

interface FeatureBlobProps {
  index: number;
}

export const FeatureBlob: React.FC<FeatureBlobProps> = ({ index }) => {
  const blobs = useMemo(() => {
    const commonClasses = `absolute opacity-30 md:opacity-100 w-auto top-0 h-full pointer-events-none ${
      index % 2 === 0 ? 'left-0' : 'right-0'
    }`;

    return [
      <FeatureBlobOne className={commonClasses} />,
      <FeatureBlobTwo className={commonClasses} />,
      <FeatureBlobThree className={commonClasses} />,
      <FeatureBlobFour className={commonClasses} />,
    ];
  }, []);

  return blobs[index];
};
